import styled from '@emotion/styled';

export const CancelConfirmCard = styled.div<{ canceled?: boolean }>`
  border-radius: 0 0 0.5rem 0.5rem;
  border-top: none;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem 1rem 1.5rem 1rem;
  align-items: ${props => props.canceled && 'center'};
`;
